{
  "nl": {
    "curriculum": {
      "confirmDelete": {
        "confirm": "Ja, verwijderen",
        "text": "Weet je zeker dat je „{filename}“ wilt verwijderen? Het bestand en de doorzoekbare leerplandoelen worden verwijderd.",
        "title": "Leerplan verwijderen?"
      },
      "confirmedUseful": "Leerplan is bevestigd voor de zoekopdracht.",
      "confirmUseful": "Bevestigen voor leerplanzoekopdracht",
      "confirmUsefulFailed": "Leerplan kon niet worden bevestigd.",
      "configure": "Leerplaninstellingen openen",
      "delete": "Leerplan verwijderen",
      "deleted": "Leerplan is verwijderd.",
      "deleteFailed": "Leerplan kon niet worden verwijderd.",
      "empty": "Nog geen eigen leerplandocumenten geüpload.",
      "documentKindDescriptions": {
        "cross_curricular_framework": "Een vakoverstijgend raamplan, bijvoorbeeld voor mediawijsheid of digitale vaardigheden.",
        "curriculum_guidance": "Een handleiding, toelichting of ondersteunend materiaal voor het werken met een leerplan.",
        "general_curriculum_part": "Een algemeen leerplangedeelte zonder specifiek vak, bijvoorbeeld met uitgangspunten of overkoepelende doelen.",
        "non_curriculum": "Dit bestand is niet herkend als een leerplandocument.",
        "presentation_or_training_material": "Presentatie- of nascholingsmateriaal over leerplannen, maar geen eigenlijk leerplan.",
        "subject_curriculum": "Een vakgericht leerplan of vakvereisten voor een concreet schoolvak.",
        "unknown": "Het documenttype kon niet betrouwbaar worden herkend."
      },
      "documentKindLabels": {
        "cross_curricular_framework": "Raamplan",
        "curriculum_guidance": "Handleiding",
        "general_curriculum_part": "Algemeen leerplangedeelte",
        "non_curriculum": "Geen leerplan",
        "presentation_or_training_material": "Presentatie / Nascholing",
        "subject_curriculum": "Vakleerplan",
        "unknown": "Onbekend"
      },
      "fields": {
        "country": "Land",
        "documentKind": "Documenttype",
        "gradeLevel": "Klasniveau",
        "region": "Regio",
        "schoolType": "Schooltype",
        "subject": "Vak",
        "title": "Titel"
      },
      "hints": {
        "customCategoryValue": "Niet gevonden? Voer een eigen waarde in."
      },
      "loading": "Leerplannen worden geladen...",
      "needsReview": "We konden dit document niet eenduidig toewijzen aan een leerplan, vak, klasniveau of schooltype. Het is daarom waarschijnlijk beperkt bruikbaar voor de leerplanzoekopdracht. Vul de gegevens aan of verwijder het bestand.",
      "notSet": "Niet ingesteld",
      "officialAvailable": "Officiële leerplangegevens zijn beschikbaar voor deze landen of regio's: {locations}. Eigen uploads vullen ontbrekende of eigen fragmenten aan.",
      "officialMissing": "Voor jouw selectie zijn nog geen officiële leerplangegevens beschikbaar. Je kunt eigen leerplandocumenten uploaden.",
      "placeholders": {
        "selectOrAddOptions": "Zoeken, selecteren of eigen waarde invoeren"
      },
      "saved": "Leerplanmetadata opgeslagen.",
      "states": {
        "classification_failed": "Automatische herkenning mislukt",
        "classifying": "Leerplan wordt geanalyseerd",
        "file_processing_failed": "Bestand kon niet worden gelezen",
        "import_failed": "Importeren mislukt",
        "indexing": "Wordt overgenomen in de leerplanzoekopdracht",
        "needs_review": "Controle nodig",
        "official": "Officieel leerplan",
        "processing_file": "Bestand wordt verwerkt",
        "searchable": "Doorzoekbaar"
      },
      "statusDescriptions": {
        "classification_failed": "De automatische herkenning kon vak, klasniveau of schooltype niet betrouwbaar bepalen. Je kunt de gegevens handmatig bewerken.",
        "classifying": "De leerplantekst wordt geanalyseerd zodat vak, klasniveau en schooltype kunnen worden voorgesteld.",
        "file_processing_failed": "Het bestand kon niet worden gelezen. Upload een ander PDF-, DOCX- of tekstbestand.",
        "import_failed": "Het leerplan kon niet worden overgenomen in de leerplanzoekopdracht. Controleer de metadata en sla opnieuw op.",
        "indexing": "Het bestand is herkend en wordt voorbereid voor de leerplanzoekopdracht.",
        "needs_review": "Het bestand is technisch verwerkt, maar de leerplanmetadata zijn onduidelijk of onvolledig.",
        "official": "Voor dit gebied zijn officiële leerplangegevens beschikbaar.",
        "processing_file": "Het bestand wordt gelezen en de tekst wordt geëxtraheerd.",
        "searchable": "Het leerplan is geïndexeerd en kan worden gebruikt door de leerplanzoekopdracht."
      },
      "title": "Leerplannen",
      "upload": "Leerplan uploaden",
      "uploaded": "Leerplan is geüpload en wordt verwerkt.",
      "uploadFailed": "Leerplan kon niet worden geüpload."
    }
  }
}
